import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCms } from "../context/CmsContext";
import { resolveCmsAssetUrl } from "../utils/cmsAssetUrl";
import "../partyBossTheme.css";

const FoodPage = () => {
  const { cms } = useCms();
  const h = cms.home;
  const navigate = useNavigate();
  const food = h.foodSection || {};

  useEffect(() => {
    document.body.classList.add("party-boss-home");
    const revealOnScroll = () => {
      document.querySelectorAll(".party-boss-reveal").forEach((item) => {
        const top = item.getBoundingClientRect().top;
        if (top < window.innerHeight - 90) item.classList.add("active");
      });
    };
    revealOnScroll();
    window.addEventListener("scroll", revealOnScroll, { passive: true });
    return () => {
      document.body.classList.remove("party-boss-home");
      window.removeEventListener("scroll", revealOnScroll);
    };
  }, []);

  return (
    <div className="party-boss-page w-full overflow-x-clip bg-[#05020a] text-white selection:bg-pink-500/40">
      <div className="party-boss-bg relative z-10 px-[5%] pb-24 pt-20 lg:px-[8%]">
        <section
          id="food"
          className="scroll-mt-28 mx-auto max-w-6xl rounded-[46px] border border-white/15 bg-gradient-to-br from-pink-500/10 to-violet-600/10 p-7 md:p-12 lg:p-16"
        >
          <div className="grid items-center gap-10 lg:grid-cols-[.9fr_1.1fr]">
            <div className="party-boss-reveal min-h-[280px] overflow-hidden rounded-[38px] shadow-[0_45px_110px_rgba(0,0,0,.5)] transition duration-500 hover:-translate-y-2 md:min-h-[360px] lg:min-h-[420px]">
              <img
                className="h-full w-full object-cover"
                src={resolveCmsAssetUrl(food.imageUrl)}
                alt="Food and banquet"
              />
            </div>
            <div className="party-boss-reveal">
              <p className="mb-2 text-sm font-black uppercase tracking-widest text-[#ffd166]">
                {food.eyebrow}
              </p>
              <h1 className="mb-4 text-3xl font-black leading-tight md:text-4xl">
                {food.title}
              </h1>
              <p className="mb-6 text-base leading-7 text-[#c9c1d9] md:text-[17px] md:leading-8">
                {food.body}
              </p>
              <div className="mb-8 flex flex-wrap gap-3">
                {(food.tags || []).map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-white/15 bg-white/10 px-3 py-2 text-sm font-extrabold md:px-4 md:py-2.5"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <button
                type="button"
                onClick={() => navigate("/booknow")}
                className="rounded-full bg-gradient-to-r from-pink-500 to-violet-600 px-7 py-3 text-sm font-black text-white shadow-xl md:text-[15px]"
              >
                {h.hero?.primaryCta || "Book now"}
              </button>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FoodPage;
